import Filters from "./FiltersComp";

export default Filters;
